import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PrintIcon from "Assets/SVG/PrintIcon";
import PrintingTypeForm from "../../../Features/Prints/Components/PrintingTypeForm";

const New = () => {
    
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('newPrintingType')} icon={<PrintIcon />} includeBox>
            <PrintingTypeForm onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default New
